/**
 * Gadget API client for the customiser (The Travellers Club).
 * Contract mirrored from Slow Burn's customiser; points at TTC's own Gadget app.
 *
 * Provides screenshot upload via the Gadget GraphQL API.
 * No build system required — plain fetch calls.
 *
 * Usage:
 *   const { id, screenshotUrl, previewPdfUrl } = await window.GadgetAPI.uploadScreenshot(canvasElement);
 */
(function () {
  'use strict';

  var API_URL = 'https://the-travellers-club-customiser.gadget.app/api/graphql';
  var PREVIEW_PDF_HOST = 'https://the-travellers-club-customiser.gadget.app';

  /**
   * Upload a canvas screenshot to Gadget and return the stored image URL.
   *
   * @param {HTMLCanvasElement} canvas - The customizer canvas element
   * @returns {Promise<{id: string, screenshotUrl: string, previewPdfUrl: string}>}
   */
  function uploadScreenshot(canvas) {
    var base64 = canvas.toDataURL('image/png').split(',').pop();

    var query = [
      'mutation CreateCartProduct($input: CreateCartProductInput!) {',
      '  createCartProduct(cartProduct: $input) {',
      '    success',
      '    cartProduct {',
      '      id',
      '      screenshots {',
      '        edges {',
      '          node {',
      '            id',
      '            image {',
      '              url',
      '            }',
      '          }',
      '        }',
      '      }',
      '    }',
      '    errors {',
      '      message',
      '    }',
      '  }',
      '}'
    ].join('\n');

    var variables = {
      input: {
        screenshots: [
          {
            create: {
              image: {
                base64: base64,
                fileName: 'screenshot_0.png'
              }
            }
          }
        ]
      }
    };

    return fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: variables })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Gadget API request failed: ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (json.errors && json.errors.length) {
          throw new Error('Gadget GraphQL error: ' + json.errors[0].message);
        }

        var result = json.data.createCartProduct;
        if (!result.success) {
          var msg = result.errors && result.errors.length ? result.errors[0].message : 'Unknown error';
          throw new Error('Gadget createCartProduct failed: ' + msg);
        }

        var cartProduct = result.cartProduct;
        var screenshotUrl = cartProduct.screenshots.edges[0].node.image.url;

        return {
          id: cartProduct.id,
          screenshotUrl: screenshotUrl,
          previewPdfUrl: PREVIEW_PDF_HOST + '/customProduct/' + cartProduct.id
        };
      });
  }

  window.GadgetAPI = {
    uploadScreenshot: uploadScreenshot
  };
})();
